const fieldsToCapture = [
  {
    inputSelector: '[data-utm-medium]',
    key: 'rs_utm_medium',
    sourceType: 'cookie'
  },
  {
    inputSelector: '[data-utm-term]',
    key: 'rs_utm_term',
    sourceType: 'cookie'
  },
  {
    inputSelector: '[data-utm-source]',
    key: 'rs_utm_source',
    sourceType: 'cookie'
  },
  {
    inputSelector: '[data-utm-content]',
    key: 'rs_utm_content',
    sourceType: 'cookie'
  },
  {
    inputSelector: '[data-utm-campaign]',
    key: 'rs_utm_campaign',
    sourceType: 'cookie'
  },
  {
    inputSelector: '[data-campaign-id]',
    key: 'campaign_id',
    sourceType: 'query-parameter'
  },
  {
    inputSelector: '[data-google-click-id]',
    key: 'rs_gclid',
    sourceType: 'cookie'
  },
  {
    inputSelector: '[data-facebook-click-id]',
    key: 'fbclid',
    sourceType: 'query-parameter'
  }
];

const getCookieByKey = (key) => {
  const match = document.cookie.match(new RegExp(`(^| )${key}=([^;]+)`));
  if (!match) {
    return null;
  }
  return match[2];
};

const getQueryParameterByKey = (key) =>
  new URLSearchParams(window.location.search).get(key);

const getFieldByKey = (sourceType, key) => {
  switch (sourceType) {
    case 'cookie':
      return getCookieByKey(key, document.cookie);
    case 'query-parameter':
      return getQueryParameterByKey(key);
    case 'url':
      return window.location.origin + window.location.pathname;
    default:
      return null;
  }
};

const captureField = ({ inputSelector, key, sourceType }) => {
  const input = document.querySelector(inputSelector);
  const value = getFieldByKey(sourceType, key);
  if (input && value) {
    input.value = value;
  }
};

export const captureAnalytics = () => {
  fieldsToCapture.forEach(captureField);
};
